import React from 'react';
import createSVG from './createSVG';

const HamburgerIcon = ({style}) => (
  <path style={style} d="M24.5 24.5H1M24.5 1H1m23.5 5.875H1m23.5 11.75H1m23.5-5.875H1" stroke="#fff" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
);

export default createSVG(HamburgerIcon);
